/**
 * Utility functions for working with needs
 */

import { type StatusType } from "@/components/ui/StatusChip";

/**
 * Get a deterministic color for a category based on its ID
 */
export const getCategoryColor = (categoryId: string): StatusType => {
  // You can add specific mappings here if needed
  // const specificMappings: Record<string, string> = {
  //   "cat_clothing": "blue",
  //   "cat_furniture": "green",
  // };
  //
  // if (specificMappings[categoryId]) return specificMappings[categoryId];

  // Simple hash function for consistent color assignment
  const hash = categoryId
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const colors: StatusType[] = [
    "blue",
    "purple",
    "green",
    "red",
    "pink",
    "yellow",
    "cyan",
    "primary",
    "secondary",
  ];

  return colors[hash % colors.length];
};

/**
 * Calculate days remaining until a due date
 * @returns Number of days or null if no due date
 */
export const getDaysRemaining = (dueDate: Date | null): number | null => {
  if (!dueDate) return null;
  const now = new Date();
  const due = new Date(dueDate);
  const diffTime = due.getTime() - now.getTime();

  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
